import React, { Component } from 'react';
import SRCards from '../../components/SRCards'
import {
  Container, FormLabel, Paper,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow
} from '@material-ui/core';
import { TablePagination } from '@mui/material';
import { TableFooter } from 'semantic-ui-react';
import CompanyApi from '../../services/company.service';
import { CHECK_NON_EMPTY_DICTIONARY } from '../../common/data-validator';

interface Column {
  id: 'name' | 'time' | 'action' | 'response' | 'tokenId' | 'result';
  label: string;
  minWidth?: number;
  align?: 'left';
  format?: (value: number) => string;
}
const columns: readonly Column[] = [
  { id: 'name', label: 'Username', minWidth: 170 },
  { id: 'action', label: 'Action Performed', minWidth: 170 },
  { id: 'time', label: 'Date & Time', minWidth: 170, align: 'left' },
  { id: 'result', label: 'Result', minWidth: 170, align: 'left' },
  { id: 'response', label: 'Response', minWidth: 170, align: 'left' },
];

type IProps = {
  location: any
}
type IState = {
  activityData: any;
  page: any;
  rowsPerPage: number;
  totalRows: any;
}
const apiservices = new CompanyApi()

class Activity extends Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      activityData: [],
      page: null,
      rowsPerPage: 10,
      totalRows: 0,
    };
  }

  async getActionData(newPage = 0) {
    let skip = newPage * this.state.rowsPerPage;
    let limit = this.state.rowsPerPage;
    let params = {
      skip: skip,
      limit: limit
    }
    let response = await apiservices.getActivity(params);
    let length = await apiservices.getActivityCount();
    this.setState({
      activityData: response,
      totalRows: length,
    })
  }

  async componentDidMount() {
    this.getActionData();
  }

  handleChangePage = (e: any, newPage: number) => {
    this.setState({
      page: newPage,
    })
    this.getActionData(newPage);
  }

  handleChangeRowsPerPage = (event: any) => {
    this.setState({
      rowsPerPage: +event.target.value,
      page: 0
    })
    
  }

  getActivitiesOnRowsChange = async (event: any) => {
    await this.handleChangeRowsPerPage(event);
    this.getActionData();
  }

  render() {
    return (
      <div>
        <SRCards />
        <Container>
          <br></br>
          <FormLabel style={{ fontSize: '15px' }}>ACTIVITY TRACKER </FormLabel>
          <br></br>
          <TableContainer
            component={Paper}
            style={{
              padding: 10, margin: 16
            }}>
            <Table
              style={{
                minWidth: 1000
              }} >
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {this.state.activityData.length > 0 ?
                this.state.activityData
                  .map((activity: any) => {
                    return (
                      <TableBody>
                        <TableRow>
                          <TableCell>{activity.userName}</TableCell>
                          <TableCell>{activity.actionPerformed}</TableCell>
                          <TableCell>{activity.time}</TableCell>
                          <TableCell>{activity.result}</TableCell>
                          <TableCell>
                          <pre>
                              {JSON.stringify(
                                CHECK_NON_EMPTY_DICTIONARY(
                                  activity.actionResponse
                                )
                                  ? activity.actionResponse
                                  : activity.errorResponse
                              )}
                            </pre>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    );
                  }) : null}
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    count={this.state.totalRows}
                    rowsPerPage={this.state.rowsPerPage}
                    page={Math.min(this.state.totalRows, this.state.page)}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.getActivitiesOnRowsChange}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </Container>
      </div>
    )
  }
}

export default Activity;